import React from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';

const Update = () => {
  return (
    <Auxiliary>
      <Title>Update Data Training</Title>
    </Auxiliary>
  );
}

export default Update;